import { create } from 'zustand'

interface EvaluationState {
  step: string
  evaluationRate: number
  keywordsList: any
  tutorPreference: number
  setInitialState: () => void
  setStep: (step: string) => void
  setEvaluationRate: (rate: number) => void
  setKeywordsList: (keywords: string[]) => void
  setTutorPreference: (preference: number) => void
}

const useEvaluationStore = create<EvaluationState>((set) => ({
  step: 'step-1',
  evaluationRate: 0,
  keywordsList: [],
  tutorPreference: 0,
  setInitialState: () =>
    set({
      step: 'step-1',
      evaluationRate: 0,
      keywordsList: [],
      tutorPreference: 0,
    }),
  setStep: (step) => set({ step }),
  setEvaluationRate: (rate) => set({ evaluationRate: rate }),
  setKeywordsList: (keywords) => set({ keywordsList: keywords }),
  setTutorPreference: (preference) => set({ tutorPreference: preference }),
}))

export default useEvaluationStore
